interface Multiplier {
  bottom: number;
  top: number;
}

export interface Industry {
  label: string;
  value: string;
}

export interface IndustryGroup {
  label: string;
  value: Industry[];
  multiplier?: Multiplier;
}

const industries: IndustryGroup[] = [
  {
    label: 'Cleaning & Maintenance',
    value: [
      {
        label: 'Cleaning',
        value: 'Cleaning',
      },
      {
        label: 'Garden, pool & outdoor maintenance',
        value: 'Garden, pool & outdoor maintenance',
      },
      {
        label: 'Handymen & Home services',
        value: 'Handymen & Home services',
      },
    ],
    multiplier: {
      bottom: 2,
      top: 3,
    },
  },
  {
    label: 'Commercial Services',
    value: [
      {
        label: 'Agriculture & Primary services',
        value: 'Agriculture & Primary services',
      },
      {
        label: 'Automotive & Marine',
        value: 'Automotive & Marine',
      },
      {
        label: 'Building & Construction',
        value: 'Building & Construction',
      },
      {
        label: 'Business services',
        value: 'Business services',
      },
      {
        label: 'Manufacturing, Wholesale & Distribution',
        value: 'Manufacturing, Wholesale & Distribution',
      },
      {
        label: 'Transport & Storage',
        value: 'Transport & Storage',
      },
      {
        label: 'Safety & Security',
        value: 'Safety & Security',
      },
      {
        label: 'Telecommunications & Internet',
        value: 'Telecommunications & Internet',
      },
    ],
  },
  {
    label: 'Food & Drink',
    value: [
      {
        label: 'Vending',
        value: 'Vending',
      },
      {
        label: 'Coffee, Cafes & Restaurants',
        value: 'Coffee, Cafes & Restaurants',
      },
      {
        label: 'Pubs, Bars & Clubs',
        value: 'Pubs, Bars & Clubs',
      },
      {
        label: 'Takeaway & Casual Dining',
        value: 'Takeaway & Casual Dining',
      },
      {
        label: 'Catering & Events',
        value: 'Catering & Events',
      },
    ],
  },
  {
    label: 'Health, Beauty & Fitness',
    value: [
      {
        label: 'Hair, Beauty & Spa',
        value: 'Hair, Beauty & Spa',
      },
      {
        label: 'Health & Medical',
        value: 'Health & Medical',
      },
      {
        label: 'Sport, Fitness & Adventure',
        value: 'Sport, Fitness & Adventure',
      },
    ],
  },
  {
    label: 'Miscellaneous',
    value: [
      {
        label: 'Accommodation & Tourism',
        value: 'Accommodation & Tourism',
      },
      {
        label: 'Master Franchises',
        value: 'Master Franchises',
      },
      {
        label: 'Entertainment & Amusement',
        value: 'Entertainment & Amusement',
      },
      {
        label: 'Green & Eco friendly',
        value: 'Green & Eco friendly',
      },
    ],
  },
  {
    label: 'Personal Services',
    value: [
      {
        label: 'Education, Coaching & Training',
        value: 'Education, Coaching & Training',
      },
      {
        label: 'Aged Care & Retirement',
        value: 'Aged Care & Retirement',
      },
      {
        label: "Children's products & services",
        value: "Children's products & services",
      },
      {
        label: 'Mortgage & Finance',
        value: 'Mortgage & Finance',
      },
      {
        label: 'Pet products & services',
        value: 'Pet products & services',
      },
      {
        label: 'Real Estate, Property & Relocation',
        value: 'Real Estate, Property & Relocation',
      },
    ],
  },
  {
    label: 'Retail',
    value: [
      {
        label: 'Fashion',
        value: 'Fashion',
      },
      {
        label: 'Food outlets',
        value: 'Food outlets',
      },
      {
        label: 'Specialty retail',
        value: 'Specialty retail',
      },
      {
        label: 'Books, Stationery & DVDs',
        value: 'Books, Stationery & DVDs',
      },
      {
        label: 'Convenience, Grocery & Liquor stores',
        value: 'Convenience, Grocery & Liquor stores',
      },
      {
        label: 'Gifts & Florists',
        value: 'Gifts & Florists',
      },
      {
        label: 'Homewares & furniture',
        value: 'Homewares & furniture',
      },
      {
        label: 'Newsagency, Lottery & Post Office',
        value: 'Newsagency, Lottery & Post Office',
      },
      {
        label: 'Discount & Variety Stores',
        value: 'Discount & Variety Stores',
      },
    ],
  },
];

export default industries;
